import type { EventsQuery } from '@/schemas/market-events'

/**
 * Query key factory.
 *
 * The key carries the whole query object rather than just the page number, so
 * changing "Rows per page" from 10 to 25 is a different cache entry and cannot
 * serve ten rows into a table that asked for twenty-five. Same reasoning
 * covers every filter: a switch from AGM to IPO, or one more letter in the
 * search box, is a different cache entry too, rather than the previous
 * filter's rows served under the new one.
 */
export const marketEventsKeys = {
  all: ['market-events'] as const,
  tables: () => [...marketEventsKeys.all, 'table'] as const,
  table: (query: EventsQuery) => [...marketEventsKeys.tables(), query] as const,
}
